<template>
  <div class="integralArea">
    <div class="con_l clearfix">
      <div class="item fl" v-for="item in goodsListData">
        <div class="picWrap">
          <div style="height: 33px">
            <div v-if="item.isLimitTime" class="limitTimeWrap">
              <span class="limitTime">{{ item.diff }}停售</span>
            </div>
          </div>
          <el-tooltip v-if="item.goodsDesc != null" effect="dark" :content="item.goodsDesc">
            <img :src="item.goodsIcon" alt="">
          </el-tooltip>
          <img v-else :src="item.goodsIcon" alt="111">

          <div class="limitWrap" v-if="item.goodsType == 1 && item.buyMaxCount > 0">
            <span class="limit">限购{{ item.buyMaxCount }}件</span>
          </div>
        </div>
        <div class="name">{{ item.goodsName }}</div>
        <div class="moneyWrap">
          <span class="money">
            <template v-if="item.currencyName == '金龙元宝'">
              <Tip :titInd="0" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            <template v-else-if="item.currencyName == '银龙元宝'">
              <Tip :titInd="1" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            <template v-else-if="item.currencyName == '积分'">
              <Tip :titInd="2" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            <template v-else-if="item.currencyName == '精品券'">
              <Tip :titInd="3" style="width:11px;vertical-align: bottom"></Tip>
            </template>
            {{ item.goodsPrice }}
          </span>
        </div>
        <template v-if="item.isTodayGet == 1">
          <div class="buyBtn">兑换</div>
        </template>
        <template v-else>
          <div v-if="item.vipLevel == 0" class="buyBtn" @click="hotBuy(item, 'exchange')">兑换</div>
          <div v-else-if="!(item.vipLevel <= VipGrade)" class="buyBtn" @click="NoBuy(item)" style="color: #fccf46;">
            仅限vip{{ item.vipLevel }}以上购买</div>
          <div v-else  class="buyBtn" @click="hotBuy(item, 'exchange')">兑换</div>
        </template>



      </div>
    </div>
    <div class="con_r">
      <div class="hotAreaConR">
        <div class="blingBox">
          <img :src="require('@/assets/imgs/shop/integralBlingBox.png')" alt="">
          <img class="blingBoxBtn" @click="goBlingBox" src="@/assets/imgs/shop/blingBoxBtn.png" alt="">
        </div>
        <div class="hotAreaConRMain">
          <HotSell :hotSellData="bestGoods" @bestBuy="hotBuy"></HotSell>
        </div>

      </div>
    </div>
    <pubMask v-if="pubMaskIsShow" :showWhich="showWhich" :goodTitle="goodTitle" :goodsPrice="goodsPrice"
      :buyOrExchange="buyOrExchange" :goodsInfo="goodsInfo" :maxCount="maxCount" @closeMask="closeMask"></pubMask>
  </div>
</template>

<script>
import HotSell from '@/components/HotSell/HotSell'
import pubMask from '@/components/pubMask'
import axios from "axios";
import Cookies from "js-cookie";
import Tip from "@/components/Tip";
import { goodsListApi, indexGoodsListApi, getGoodsByMaxCountApi } from "@/api/home/index.js";
export default {
  name: "integralArea",
  components: {
    HotSell,          // 爆款热卖
    pubMask,          // 公用弹窗
    Tip
  },
  props: {
    type: '',
  },
  data() {
    return {
      isIntegerOrShop: this.type,     //  是积分专区还是精品商城
      pubMaskIsShow: false,  // 是否显示弹窗
      showWhich: 7,        // 当前显示弹窗是购买弹窗
      goodTitle: '',       // 商品名称
      goodsPrice: 0,       // 商品价格
      maxCount: 0,         // 最大购买数量
      buyOrExchange: null, // 购买还是兑换

      goodsListData: [],   // 商品数据
      bestGoods: [],       // 爆款数据

      VipGrade: '', //vip等级
      userInfo: ''
    }
  },
  created() {
    //this.getGoodsList()               // 获取积分列表数据
    this.indexGoodsList(2)    // 获取爆款数据

    // console.log(this.type,'type');

  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : ''
    if (userInfo) {
      this.VipGrade = Number(userInfo ? userInfo.vipInfo.viplevel.match(/\d+/)[0] : 0)
    }
  },
  methods: {


    NoBuy(item) {
      this.$message.info(`仅限vip${item.vipLevel}以上购买`)
    },

    async hotBuy(item, exchange) {               // 热卖购买弹窗,积分兑换
      if (Cookies.get('cwsl_token')) {

        if (item.buyMaxCount == 0 || item.buyMaxCount == null) {
          // axios({
          //   method: 'post',
          //   url: '/shop/order/getGoodsByMaxCount',
          //   headers: {
          //     token: Cookies.get('cwsl_token'),
          //   },
          //   data: {

          //   }
          // })
          await getGoodsByMaxCountApi({
            goodsId: item.goodsId,
            platForm: 'web',
            userId: Cookies.get('cwsl_userId')
          }).then(res => {
            if (res.data.state == 200) {
              this.maxCount = res.data.data.maxCount
              this.goodsInfo = item
              this.goodTitle = item.goodsName
              this.goodsPrice = item.goodsPrice
              this.showWhich = 7
              if (exchange) {
                this.buyOrExchange = exchange
              } else {
                this.buyOrExchange = ''
              }
              this.pubMaskIsShow = true
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.maxCount = item.buyMaxCount
          this.goodsInfo = item
          this.goodTitle = item.goodsName
          this.goodsPrice = item.goodsPrice
          this.showWhich = 7
          if (exchange) {
            this.buyOrExchange = exchange
          } else {
            this.buyOrExchange = ''
          }
          this.pubMaskIsShow = true
        }
      } else {
        this.$message.error('请先登录')
      }
    },
    async getGoodsList(cateId) {                   // 获取积分列表数据4：积分，5：商城
      await goodsListApi({
        cateId: cateId,
        order: {
          addTime: 'addTime'
        },
        pageNum: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.state == 200) {
          this.goodsListData = res.data.data.list.map(item => {
            let diffTime = item.endTime // - res.data.data.superGoods.curTimestamp
            if (diffTime > 0) {
              let date = new Date(parseInt(diffTime) * 1000);
              let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
              let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
              let Hours = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
              item.diff = Moth + '月' + Day + '日' + Hours + '时'
            } else {
              item.diff = 0
            }
            return item
          }) // 爆款
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    async indexGoodsList(cateId) {     //  cateId: 1:热卖区 2：爆款，3：超值

      await indexGoodsListApi({
        cateId: cateId,
        order: {
          publishDate: 'publishDate'
        },
        pageNum: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.state == 200) {
          this.bestGoods = res.data.data.bestGoods.list   // 爆款数据

        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    goBlingBox() {   // 进入盲盒页面
      this.$router.push({ path: '/shop/blindBox' })
      document.scrollingElement.scrollTop = 0
    },
    closeMask() {                // 关闭弹窗
      this.pubMaskIsShow = false
    },
  },
  watch: {
    type: {
      handler(newv) {
        this.isIntegerOrShop = newv
        if (this.isIntegerOrShop == 'integralArea') {
          this.getGoodsList(4)
        } else {
          this.getGoodsList(5)
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  }
}
</script>

<style scoped lang="less">
.integralArea {
  display: flex;

  .con_l {
    width: 65%;
    overflow: hidden;

    .item {
      margin-bottom: 20px;
      float: left;
      width: 136px;
      margin-right: 7px;

      .picWrap {
        text-align: center;
        width: 128px;
        height: 120px;
        border: 4px solid #5472F6;
        overflow: hidden;

        img {
          height: 64px;
        }

        .limitTimeWrap {
          padding-top: 8px;
          text-align: center;
          background: url("../../../assets/imgs/shop/superValueLimit.png") no-repeat top center;

          .limitTime {
            display: inline-block;
            width: 110px;
            height: 25px;
            color: #fff;
            font-size: 12px;
          }
        }

        .limitWrap {
          .limit {
            margin-top: 2px;
            display: inline-block;
            width: 100px;
            height: 20px;
            line-height: 20px;
            color: #fff;
            font-size: 12px;
            background: #5472F6;
          }
        }
      }

      .name {
        padding: 10px 0;
        font-size: 14px;
        text-align: center;
        color: #333;
        font-weight: 700;
        height: 34px;
        box-sizing: border-box;
      }

      .moneyWrap {
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 2px;
        overflow: hidden;

        .money {
          width: 100%;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: #fff;
          background: #555555;
        }

        /* .moneyUnit{
            width:56px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #555555;
          }*/
      }

      .buyBtn {
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        background: #5472F6;
      }

      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }

  .con_r {
    width: 35%;

    .blingBox {
      position: relative;
      margin-bottom: 20px;

      img {
        width: 100%;
      }

      .blingBoxBtn {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        width: 130px;
      }
    }

    .hotAreaConR {
      box-shadow: 0 0 20px #dddddd;

      .hotAreaConRMain {
        position: relative;
        z-index: 0;
        background: #E3E8FF;

      }
    }
  }
}
</style>
